"use client";
import { createI18nClient } from "next-international/client";
import { availableLocales } from "./available-locales";
import en from "./en";

export const {
    useI18n,
    useScopedI18n,
    I18nProviderClient,
    useChangeLocale,
    useCurrentLocale,
} = createI18nClient(availableLocales, { fallbackLocale: en });

export type I18n = ReturnType<typeof useI18n>;
